import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import categories from 'src/app/data/categories';
import { ProductService } from 'src/app/services/product-service/product.service';
import { ShopServiceService } from 'src/app/services/shop-service.service';
import { TypeItemServiceService } from 'src/app/services/type-item-servive/type-item-service.service';
import { ModalPopPage } from '../modal-pop/modal-pop.page';
import { Product } from '../models/type/product.model';
import { Shop } from '../models/type/shop.model';
import { Type } from '../models/type/type.model';
import { take } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login/login.service';

interface Point {
  pointName: string;
  address: string;
}

interface User {
  email: string;
  phone: string;
  role: string;
  hasAgentRole?: boolean;
  User: string;
  userID: string;
}

@Component({
  selector: 'app-landing',
  templateUrl: './landing.page.html',
  styleUrls: ['./landing.page.scss'],
})
export class LandingPage implements OnInit {
  types: Type[] = categories;
  products: Product[] = [];
  // shops: Shop[] = [];
  shops = [];

  storePoints = [];

  constructor(
    private typeItemService: TypeItemServiceService,
    private router: Router,
    private productService: ProductService,
    private shopService: ShopServiceService,
    private modalCtrl: ModalController,
    private auth: AngularFireAuth,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.checkAuth();
    // this.getShops();
    // this.getProducts();
    this.getStorePoints();
  }

  getShops() {
    this.shopService.getShops().subscribe((res) => {
      this.shops = res.map((shop) => shop.payload.doc.data() as Shop);
      // console.log(this.shops);
    });
  }

  getProducts() {
    this.productService.getPoducts().subscribe((res) => {
      this.products = res.map(
        (product) => product.payload.doc.data() as Product
      );
    });
  }

  checkAuth() {
    this.auth.authState.pipe(take(1)).subscribe((user) => {
      if (!user) {
        this.router.navigate(['/home/login']);
      } else {
        // const { uid, email } = user;
        // this.loginService
        //   .verifyID(uid)
        //   .pipe(take(1))
        //   .subscribe((res) => {
        //     const user = res.data() as User;
        //     // console.log(user);
        //     // if (user.role === '') {
        //     //   this.router.navigate()
        //     // }
        //   });
      }
    });
  }

  doRefresh(event) {
    // console.log('Begin async operation');

    setTimeout(() => {
      // console.log('Async operation has ended');
      this.getStorePoints();
      event.target.complete();
    }, 3000);
  }

  openModal() {
    this.modalCtrl.create({ component: ModalPopPage }).then((modalElement) => {
      modalElement.present();
    });
  }

  openPointModal(docID, pointName, address, menuUrl) {
    this.modalCtrl
      .create({
        component: ModalPopPage,
        componentProps: {
          docID,
          pickUpPointAddress: address,
          pointName: pointName,
          menuUrl,
        },
      })
      .then((modalElement) => {
        modalElement.present();
      });
  }

  getStorePoints() {
    this.shopService.getStorePoints().subscribe((res) => {
      this.storePoints = res.map((point) => ({
        docID: point.payload.doc.id,
        ...(point.payload.doc.data() as Point),
      }));
      // console.log(this.storePoints);
    });
  }

  goToCategory(id: number) {
    if (id !== 1) {
      this.router.navigate(['home/category', id]);
    }
  }

  home() {
    this.router.navigate(['home/landing']);
  }

  about() {
    this.router.navigate(['home/about']);
  }

  track() {
    this.router.navigate(['track-order']);
  }

  cart() {
    this.router.navigate(['home/cart']);
  }

  login() {
    this.router.navigate(['home/login']);
  }

  allshops() {
    this.router.navigate(['all-shops']);
  }
  goToShop(id: number) {
    this.router.navigate(['home/products', id]);
  }
  //***********Top Shops Test */
}
